import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function POSBilling() {
  const [step, setStep] = useState(1);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [cart, setCart] = useState([]);
  const [customerMobile, setCustomerMobile] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [gstPercent, setGstPercent] = useState(18);
  const [loading, setLoading] = useState(false);
  const [bill, setBill] = useState(null);
  const [showKeypad, setShowKeypad] = useState(false);
  const [receiptType, setReceiptType] = useState('');
  const [receiptMobile, setReceiptMobile] = useState('');
  const [showReceiptKeypad, setShowReceiptKeypad] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [smsPopup, setSmsPopup] = useState(false);
  const [printPopup, setPrintPopup] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const mobileInputRef = useRef(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('csk_token');
  const user = JSON.parse(localStorage.getItem('csk_user') || '{}');

  useEffect(() => {
    if (!token) { navigate('/login'); return; }
    fetchProducts(); fetchCategories();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API}/products.php?action=list`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) setProducts(res.data.data);
    } catch (err) { console.error(err); }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API}/products.php?action=categories`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) setCategories(res.data.data);
    } catch (err) { console.error(err); }
  };

  const addToCart = (product) => {
    const existing = cart.find(c => c.product_id === product.id);
    if (existing) {
      setCart(cart.map(c => c.product_id === product.id ? { ...c, quantity: c.quantity + 1, total: (c.quantity + 1) * c.price } : c));
    } else {
      setCart([...cart, { product_id: product.id, product_name: product.name, price: parseFloat(product.price), quantity: 1, total: parseFloat(product.price) }]);
    }
  };

  const updateQty = (product_id, qty) => {
    if (qty < 1) { setCart(cart.filter(c => c.product_id !== product_id)); return; }
    setCart(cart.map(c => c.product_id === product_id ? { ...c, quantity: qty, total: qty * c.price } : c));
  };

  const subtotal = cart.reduce((sum, c) => sum + c.total, 0);
  const gstAmount = (subtotal * gstPercent) / 100;
  const total = subtotal + gstAmount;

  const handleKeypad = (key) => {
    if (key === 'C') { setCustomerMobile(''); return; }
    if (key === '⌫') { setCustomerMobile(prev => prev.slice(0, -1)); return; }
    if (customerMobile.length < 10) setCustomerMobile(prev => prev + key);
  };

  const handleReceiptKeypad = (key) => {
    if (key === 'C') { setReceiptMobile(''); return; }
    if (key === '⌫') { setReceiptMobile(prev => prev.slice(0, -1)); return; }
    if (receiptMobile.length < 10) setReceiptMobile(prev => prev + key);
  };

  const handleCreateBill = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/bills.php?action=create`, {
        customer_name: 'Customer', customer_mobile: customerMobile,
        items: cart, gst_percent: gstPercent, payment_method: paymentMethod,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) {
        setBill({ bill_number: res.data.bill_number, customer_mobile: customerMobile, items: [...cart], subtotal, gst_percent: gstPercent, gst_amount: gstAmount, total, payment_method: paymentMethod, date: new Date().toLocaleDateString('en-IN') });
        setReceiptMobile(customerMobile);
        setStep(3);
      }
    } catch (err) { alert('Error creating bill!'); }
    finally { setLoading(false); }
  };

  const handleNewBill = () => {
    setStep(1); setCart([]); setCustomerMobile(''); setPaymentMethod('cash');
    setBill(null); setShowKeypad(false); setReceiptType('');
    setReceiptMobile(''); setShowReceiptKeypad(false); setShowSuccess(false);
    setSmsPopup(false);
    setPrintPopup(false);
    fetchProducts();
  };

  const handleProceed = () => {
  if (!receiptType) { alert('Please choose receipt pickup option!'); return; }

  if (receiptType === 'sms') {
    if (!receiptMobile || receiptMobile.length !== 10) {
      alert('Please enter valid 10 digit mobile number!');
      setShowReceiptKeypad(true);
      return;
    }
    setSmsPopup(true);
    setTimeout(() => {
      setSmsPopup(false);
      setShowSuccess(true);
      setTimeout(() => { handleNewBill(); }, 2500);
    }, 5000);
  } else {
    const printContent = `
      <html>
        <head>
          <title>Bill - ${bill?.bill_number}</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: 'Courier New', monospace; font-size: 14px; color: #000; background: #fff; padding: 10px; }
            @media print { @page { size: auto; margin: 3mm; } body { width: auto; } }
            table { width: 100%; border-collapse: collapse; }
            th, td { padding: 2px 0; }
            .divider { border-top: 1px dashed #000; margin: 6px 0; }
            .center { text-align: center; }
            .right { text-align: right; }
            .bold { font-weight: bold; }
            .large { font-size: 15px; }
            .small { font-size: 10px; }
            .total-row { font-size: 14px; font-weight: 900; }
          </style>
        </head>
        <body>
          <div class="center" style="margin-bottom:8px;">
            <div class="bold large" style="letter-spacing:2px;">CSK SPORTSWEAR</div>
            <div class="small">Chennai, Tamil Nadu</div>
            <div class="small">Ph: +91 XXXXXXXXXX</div>
          </div>
          <div class="divider"></div>
          <div style="margin-bottom:6px;">
            <div><span class="bold">Bill No:</span> ${bill?.bill_number}</div>
            <div><span class="bold">Date:</span> ${bill?.date}</div>
            <div><span class="bold">Mobile:</span> ${receiptMobile || '-'}</div>
            <div><span class="bold">Payment:</span> ${bill?.payment_method?.toUpperCase()}</div>
          </div>
          <div class="divider"></div>
          <table>
            <thead>
              <tr>
                <th style="text-align:left;">Item</th>
                <th style="text-align:center;">Qty</th>
                <th style="text-align:right;">Rate</th>
                <th style="text-align:right;">Amt</th>
              </tr>
            </thead>
            <tbody>
              <tr><td colspan="4"><div class="divider"></div></td></tr>
              ${bill?.items?.map(item => `
                <tr>
                  <td style="text-align:left;">${item.product_name}</td>
                  <td style="text-align:center;">${item.quantity}</td>
                  <td style="text-align:right;">&#8377;${item.price.toFixed(2)}</td>
                  <td style="text-align:right;">&#8377;${item.total.toFixed(2)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div class="divider"></div>
          <table>
            <tr><td>Subtotal</td><td class="right">&#8377;${bill?.subtotal?.toFixed(2)}</td></tr>
            <tr><td>GST (${bill?.gst_percent}%)</td><td class="right">&#8377;${bill?.gst_amount?.toFixed(2)}</td></tr>
          </table>
          <div class="divider"></div>
          <table>
            <tr class="total-row">
              <td class="bold">TOTAL</td>
              <td class="right bold">&#8377;${bill?.total?.toFixed(2)}</td>
            </tr>
          </table>
          <div class="divider"></div>
          <div class="center small" style="margin-top:8px;">
            <div>Thank you for shopping!</div>
            <div>Visit again - CSK Sportswear</div>
            <div style="margin-top:4px;">Powered by Veltrix Technologies</div>
          </div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.focus();
                window.print();
                window.onafterprint = function() { window.close(); };
              }, 300);
            };
          </script>
        </body>
      </html>
    `;
    const printWindow = window.open('', '_blank', 'width=800,height=900,left=200,top=50');
    printWindow.document.write(printContent);
    printWindow.document.close();
    setPrintPopup(true);
    setTimeout(() => {
      setPrintPopup(false);
      setShowSuccess(true);
      setTimeout(() => { handleNewBill(); }, 2500);
    }, 5000);
  }
};

  const filteredProducts = activeCategory === 'All' ? products : products.filter(p => p.category_name === activeCategory);

  const menuItems = user.role === 'cashier' ? [
  { path: '/cashier/pos', label: 'POS Billing', icon: '🧾' },
] : [
  { path: '/admin/dashboard', label: 'Dashboard', icon: '🏠' },
  { path: '/admin/inventory', label: 'Inventory', icon: '📦' },
  { path: '/admin/pos', label: 'POS Billing', icon: '🧾' },
  { path: '/admin/reports', label: 'Reports', icon: '📊' },
  { path: '/admin/users', label: 'Users', icon: '👥' },
];

  const styles = `
    * { box-sizing: border-box; }
    .pos-sidebar {
      width: 200px; background: #000;
      border-right: 1px solid rgba(255,255,255,0.08);
      display: flex; flex-direction: column;
      position: fixed; top: 0; left: 0; bottom: 0;
      z-index: 100; transition: transform 0.3s ease;
    }
    .pos-mobile-hdr {
      display: none; background: #000;
      padding: 12px 16px; position: fixed;
      top: 0; left: 0; right: 0; z-index: 99;
      border-bottom: 1px solid rgba(255,255,255,0.08);
      align-items: center; justify-content: space-between;
    }
    .pos-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.7); z-index: 98; }
    .pos-nav-link {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; color: #475569; font-size: 13px;
      font-weight: 500; text-decoration: none;
      border-left: 3px solid transparent; transition: all 0.2s;
    }
    .pos-nav-link:hover { color: white; background: rgba(255,255,255,0.05); }
    .pos-nav-link.active { color: white; background: rgba(0,102,255,0.1); border-left-color: #0066FF; }
    .pos-main { margin-left: 200px; flex: 1; display: flex; flex-direction: column; min-height: 100vh; background: #0A0A0A; }
    .pos-content { display: flex; flex: 1; overflow: hidden; height: calc(100vh - 50px); }
    .pos-products { flex: 1; padding: 16px; overflow-y: auto; background: #0A0A0A; }
    .pos-cart { width: 300px; background: #111; border-left: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; }
    .pos-product-card {
      background: rgba(255,255,255,0.04); border-radius: 10px; padding: 16px;
      cursor: pointer; border: 2px solid rgba(255,255,255,0.06);
      transition: all 0.15s; position: relative;
    }
    .pos-product-card:hover { border-color: #0066FF; background: rgba(0,102,255,0.08); transform: translateY(-2px); }
    .pos-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; }
    .pos-cat-btn { padding: 7px 16px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.7); font-size: 12px; font-weight: 600; cursor: pointer; white-space: nowrap; transition: all 0.2s; }
    .pos-cat-btn.active { background: #0066FF; border-color: #0066FF; color: white; }
    .pos-cat-btn:hover { background: rgba(0,102,255,0.2); border-color: rgba(0,102,255,0.4); }
    .pos-cart-fab { display: none; }
    .pos-bottom-bar { display: none; }
    @media (max-width: 768px) {
      .pos-sidebar { transform: translateX(-100%); }
      .pos-sidebar.open { transform: translateX(0); }
      .pos-mobile-hdr { display: flex; }
      .pos-overlay.show { display: block; }
      .pos-main { margin-left: 0; padding-top: 52px; }
      .pos-content { height: auto; flex-direction: column; overflow: visible; }
      .pos-cart { display: none !important; }
      .pos-products { padding: 12px; padding-bottom: 100px; overflow: visible; }
      .pos-cart-fab { display: flex; position: fixed; bottom: 72px; right: 16px; width: 56px; height: 56px; background: #0066FF; border-radius: 50%; align-items: center; justify-content: center; font-size: 22px; cursor: pointer; box-shadow: 0 4px 20px rgba(0,102,255,0.4); z-index: 50; border: none; flex-direction: column; gap: 1px; }
      .pos-bottom-bar { display: flex !important; position: fixed; bottom: 0; left: 0; right: 0; padding: 10px 16px; background: #111; border-top: 1px solid rgba(255,255,255,0.08); z-index: 50; align-items: center; gap: 12px; }
      .pos-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 10px; }
      .pos-cats { overflow-x: auto; flex-wrap: nowrap !important; padding-bottom: 4px; -webkit-overflow-scrolling: touch; }
      .pos-cats::-webkit-scrollbar { height: 2px; }
    }
    .pay-main { margin-left: 200px; flex: 1; display: flex; flex-direction: column; min-height: 100vh; background: #0A0A0A; }
    .pay-content { display: flex; flex: 1; }
    .pay-tabs { width: 160px; background: #111; border-right: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; padding: 16px 0; }
    .pay-center { flex: 1; padding: 20px; overflow-y: auto; }
    .pay-right { width: 300px; background: #111; border-left: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; }
    .pay-tab-btn { display: flex; align-items: center; gap: 10px; padding: 14px 16px; border: none; border-left: 4px solid transparent; background: transparent; color: #475569; font-size: 14px; font-weight: 500; cursor: pointer; text-align: left; width: 100%; transition: all 0.2s; }
    .pay-tab-btn.active { border-left-color: #0066FF; background: rgba(0,102,255,0.1); color: white; font-weight: 700; }
    .pay-tab-btn:hover { color: white; background: rgba(255,255,255,0.05); }
    .pay-card { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 20px; margin-bottom: 16px; }
    .pay-input { width: 100%; padding: 12px 16px; border: 2px solid rgba(255,255,255,0.1); border-radius: 8px; font-size: 22px; font-weight: 800; color: white; letter-spacing: 4px; outline: none; background: rgba(255,255,255,0.05); }
    .pay-input:focus { border-color: #0066FF; }
    .kpad-btn { padding: 16px; border: none; border-radius: 7px; font-size: 20px; font-weight: 700; cursor: pointer; transition: opacity 0.1s; }
    .kpad-btn:hover { opacity: 0.85; }
    .pay-method-mobile { display: none; }
    @media (max-width: 768px) {
      .pos-sidebar { transform: translateX(-100%); }
      .pos-sidebar.open { transform: translateX(0); }
      .pos-mobile-hdr { display: flex; }
      .pos-overlay.show { display: block; }
      .pay-main { margin-left: 0; padding-top: 52px; }
      .pay-tabs { display: none; }
      .pay-content { flex-direction: column; }
      .pay-right { width: 100%; border-left: none; border-top: 1px solid rgba(255,255,255,0.08); }
      .pay-method-mobile { display: flex !important; gap: 8px; margin-bottom: 16px; }
      .pay-center { padding: 12px; }
    }
    .rec-center { margin-left: 200px; flex: 1; display: flex; align-items: center; justify-content: center; padding: 24px; min-height: 100vh; background: #0A0A0A; }
    .rec-box { background: #111; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; width: 600px; overflow: hidden; }
    .rec-opt-btn { padding: 24px 16px; border-radius: 12px; background: rgba(255,255,255,0.03); cursor: pointer; text-align: center; transition: all 0.2s; border: 2px solid rgba(255,255,255,0.08); }
    .rec-opt-btn.selected { border-color: #0066FF; background: rgba(0,102,255,0.1); }
    .rec-opt-btn:hover { border-color: rgba(0,102,255,0.4); }
    @media (max-width: 768px) {
      .pos-sidebar { transform: translateX(-100%); }
      .pos-sidebar.open { transform: translateX(0); }
      .pos-mobile-hdr { display: flex; }
      .pos-overlay.show { display: block; }
      .rec-center { margin-left: 0; padding: 68px 12px 24px; align-items: flex-start; }
      .rec-box { width: 100%; }
    }
  `;

  const Sidebar = () => (
    <div className={`pos-sidebar ${sidebarOpen ? 'open' : ''}`}>
      <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#DC2626', fontSize: '22px' }}>★</span>
          <div>
            <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: 800, letterSpacing: '2px', color: 'white' }}>CSK</div>
            <div style={{ fontSize: '8px', color: '#475569', letterSpacing: '1px' }}>POS SYSTEM</div>
          </div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '8px 0' }}>
        {menuItems.map(item => (
          <Link key={item.path} to={item.path}
            className={`pos-nav-link ${window.location.pathname === item.path ? 'active' : ''}`}
            onClick={() => setSidebarOpen(false)}>
            <span>{item.icon}</span>{item.label}
          </Link>
        ))}
      </nav>
      <div style={{ padding: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <button onClick={() => { localStorage.clear(); navigate('/login'); }} style={{ width: '100%', padding: '8px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>🚪 Logout</button>
      </div>
      {showSuccess && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#111', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '40px', textAlign: 'center', maxWidth: '320px', width: '90%' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>✅</div>
            <div style={{ fontFamily: 'Montserrat', fontWeight: 900, fontSize: '22px', color: '#16A34A', marginBottom: '8px' }}>BILL SUCCESS!</div>
            <div style={{ color: '#475569', fontSize: '14px', marginBottom: '8px' }}>{bill?.bill_number}</div>
            <div style={{ fontSize: '28px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>₹{bill?.total?.toFixed(2)}</div>
            <div style={{ color: '#475569', fontSize: '12px' }}>Redirecting to POS...</div>
          </div>
        </div>
      )}
    </div>
  );
  {/* SMS Popup */}
{smsPopup && (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
    <div style={{ background: '#111', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '40px', textAlign: 'center', maxWidth: '320px', width: '90%' }}>
      <div style={{ fontSize: '64px', marginBottom: '16px' }}>📱</div>
      <div style={{ fontFamily: 'Montserrat', fontWeight: 900, fontSize: '20px', color: 'white', marginBottom: '8px' }}>SMS SENT!</div>
      <div style={{ color: '#475569', fontSize: '14px', marginBottom: '16px' }}>Bill sent to {receiptMobile}</div>
      <div style={{ fontSize: '28px', fontWeight: 800, color: '#0066FF', marginBottom: '16px' }}>₹{bill?.total?.toFixed(2)}</div>
      <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '8px', padding: '8px', fontSize: '12px', color: '#475569' }}>
        Auto closing in 5 seconds...
      </div>
    </div>
  </div>
)}

{/* Print Popup */}
{printPopup && (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
    <div style={{ background: '#111', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '40px', textAlign: 'center', maxWidth: '320px', width: '90%' }}>
      <div style={{ fontSize: '64px', marginBottom: '16px' }}>🖨️</div>
      <div style={{ fontFamily: 'Montserrat', fontWeight: 900, fontSize: '20px', color: 'white', marginBottom: '8px' }}>PRINTING...</div>
      <div style={{ color: '#475569', fontSize: '14px', marginBottom: '16px' }}>Bill {bill?.bill_number}</div>
      <div style={{ fontSize: '28px', fontWeight: 800, color: '#0066FF', marginBottom: '16px' }}>₹{bill?.total?.toFixed(2)}</div>
      <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '8px', padding: '8px', fontSize: '12px', color: '#475569' }}>
        Auto closing in 5 seconds...
      </div>
    </div>
  </div>
)}

  // STEP 1
  if (step === 1) return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{styles}</style>

      <div className="pos-mobile-hdr">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer' }}>☰</button>
        <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white', letterSpacing: '1px' }}>POS BILLING</span>
        <span style={{ color: '#0066FF', fontSize: '13px', fontWeight: 700 }}>{cart.length} items</span>
      </div>

      <div className={`pos-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />
      <Sidebar />

      <div className="pos-main">
        {/* Header */}
        <div style={{ background: '#000', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white', letterSpacing: '1px' }}>ADD ITEMS</h1>
          <div style={{ color: '#475569', fontSize: '11px' }}>
            {new Date().toLocaleString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>

        {/* Categories */}
        <div style={{ background: '#000', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '10px 16px' }}>
          <div className="pos-cats" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {['All', ...categories.map(c => c.name)].map(cat => (
              <button key={cat} className={`pos-cat-btn ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>{cat}</button>
            ))}
          </div>
        </div>

        <div className="pos-content">
          {/* Products */}
          <div className="pos-products">
            <div className="pos-grid">
              {filteredProducts.map(p => (
                <div key={p.id} className="pos-product-card" onClick={() => addToCart(p)}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: p.stock > 0 ? '#16A34A' : '#DC2626', position: 'absolute', top: '12px', right: '12px' }} />
                  <div style={{ fontSize: '10px', color: '#0066FF', fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '1px' }}>{p.category_name}</div>
                  <div style={{ fontSize: '14px', fontWeight: 700, color: 'white', marginBottom: '8px', lineHeight: 1.3 }}>{p.name}</div>
                  <div style={{ fontSize: '18px', fontWeight: 800, color: 'white' }}>₹{parseFloat(p.price).toFixed(2)}</div>
                  <div style={{ fontSize: '10px', color: '#475569', marginTop: '3px' }}>Stock: {p.stock}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Desktop Cart */}
          <div className="pos-cart">
            <div style={{ padding: '14px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ fontSize: '11px', color: '#475569', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase' }}>Order Summary</div>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '8px 12px' }}>
              {cart.length === 0 ? (
                <div style={{ textAlign: 'center', color: '#475569', padding: '40px 0', fontSize: '13px' }}>Click products to add</div>
              ) : cart.map(item => (
                <div key={item.product_id} style={{ padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{item.product_name}</div>
                      <div style={{ fontSize: '11px', color: '#475569' }}>₹{item.price} each</div>
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: 700, color: 'white' }}>₹{item.total.toFixed(2)}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <button onClick={() => updateQty(item.product_id, item.quantity - 1)} style={{ width: '26px', height: '26px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', cursor: 'pointer', fontSize: '16px', fontWeight: 700, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>-</button>
                    <span style={{ fontSize: '14px', fontWeight: 800, minWidth: '24px', textAlign: 'center', color: 'white' }}>{item.quantity}</span>
                    <button onClick={() => updateQty(item.product_id, item.quantity + 1)} style={{ width: '26px', height: '26px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', cursor: 'pointer', fontSize: '16px', fontWeight: 700, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              <select value={gstPercent} onChange={e => setGstPercent(Number(e.target.value))} style={{ width: '100%', padding: '8px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', fontSize: '13px', marginBottom: '10px', outline: 'none', background: '#1E293B', color: 'white' }}>
                <option value={0}>No GST</option>
                <option value={5}>GST 5%</option>
                <option value={12}>GST 12%</option>
                <option value={18}>GST 18%</option>
              </select>
              <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '8px', padding: '10px', marginBottom: '10px', border: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569', marginBottom: '4px' }}><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569', marginBottom: '6px' }}><span>GST ({gstPercent}%)</span><span>₹{gstAmount.toFixed(2)}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 800, color: 'white' }}><span>Grand Total</span><span>₹{total.toFixed(2)}</span></div>
              </div>
              <button onClick={() => { if (cart.length === 0) { alert('Add products!'); return; } setStep(2); }} style={{ width: '100%', padding: '13px', background: cart.length > 0 ? 'linear-gradient(135deg, #0066FF, #0052CC)' : 'rgba(255,255,255,0.1)', color: cart.length > 0 ? 'white' : '#475569', border: 'none', borderRadius: '6px', fontSize: '14px', fontWeight: 800, cursor: cart.length > 0 ? 'pointer' : 'not-allowed', letterSpacing: '1px' }}>PROCEED →</button>
            </div>
          </div>
        </div>

        {/* Mobile Cart FAB */}
        <button className="pos-cart-fab" onClick={() => setShowCart(true)}>
          <span>🛒</span>
          {cart.length > 0 && <span style={{ fontSize: '10px', fontWeight: 800, color: 'white' }}>{cart.length}</span>}
        </button>

        {/* Mobile Bottom Bar */}
        <div className="pos-bottom-bar">
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '11px', color: '#475569' }}>Total ({cart.length} items)</div>
            <div style={{ fontSize: '18px', fontWeight: 800, color: 'white' }}>₹{total.toFixed(2)}</div>
          </div>
          <button onClick={() => { if (cart.length === 0) { alert('Add products!'); return; } setStep(2); }} style={{ padding: '12px 28px', background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 800, cursor: 'pointer' }}>PROCEED →</button>
        </div>

        {/* Mobile Cart Modal */}
        {showCart && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 200, display: 'flex', alignItems: 'flex-end' }}>
            <div style={{ background: '#111', border: '1px solid rgba(255,255,255,0.08)', width: '100%', borderRadius: '16px 16px 0 0', padding: '20px', maxHeight: '80vh', overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '16px', color: 'white' }}>Order Summary</h3>
                <button onClick={() => setShowCart(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#475569' }}>✕</button>
              </div>
              {cart.length === 0 ? (
                <div style={{ textAlign: 'center', color: '#475569', padding: '24px 0' }}>No items added</div>
              ) : cart.map(item => (
                <div key={item.product_id} style={{ padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>{item.product_name}</div>
                    <div style={{ fontSize: '14px', fontWeight: 700, color: 'white' }}>₹{item.total.toFixed(2)}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <button onClick={() => updateQty(item.product_id, item.quantity - 1)} style={{ width: '32px', height: '32px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', cursor: 'pointer', fontSize: '18px', fontWeight: 700, color: 'white' }}>-</button>
                    <span style={{ fontSize: '16px', fontWeight: 800, minWidth: '24px', textAlign: 'center', color: 'white' }}>{item.quantity}</span>
                    <button onClick={() => updateQty(item.product_id, item.quantity + 1)} style={{ width: '32px', height: '32px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', cursor: 'pointer', fontSize: '18px', fontWeight: 700, color: 'white' }}>+</button>
                    <span style={{ fontSize: '12px', color: '#475569' }}>₹{item.price} each</span>
                  </div>
                </div>
              ))}
              <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                <select value={gstPercent} onChange={e => setGstPercent(Number(e.target.value))} style={{ width: '100%', padding: '8px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', fontSize: '13px', marginBottom: '10px', outline: 'none', background: '#1E293B', color: 'white' }}>
                  <option value={0}>No GST</option>
                  <option value={5}>GST 5%</option>
                  <option value={12}>GST 12%</option>
                  <option value={18}>GST 18%</option>
                </select>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569', marginBottom: '4px' }}><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569', marginBottom: '8px' }}><span>GST ({gstPercent}%)</span><span>₹{gstAmount.toFixed(2)}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 800, color: 'white' }}><span>TOTAL</span><span>₹{total.toFixed(2)}</span></div>
              </div>
              <button onClick={() => { setShowCart(false); if (cart.length === 0) { alert('Add products!'); return; } setStep(2); }} style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: 800, cursor: 'pointer' }}>PROCEED →</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // STEP 2
  if (step === 2) return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{styles}</style>

      <div className="pos-mobile-hdr">
        <button onClick={() => setStep(1)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white' }}>PAYMENT</span>
        <span style={{ color: '#0066FF', fontSize: '14px', fontWeight: 800 }}>₹{total.toFixed(2)}</span>
      </div>

      <div className={`pos-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />
      <Sidebar />

      <div className="pay-main">
        <div style={{ background: '#000', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '10px 20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setStep(1)} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '6px', padding: '6px 14px', color: 'white', cursor: 'pointer', fontSize: '14px' }}>← Back</button>
          <h1 style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white', letterSpacing: '1px' }}>PAYMENT</h1>
        </div>

        <div className="pay-content">
          {/* Desktop Payment Tabs */}
          <div className="pay-tabs">
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#475569', letterSpacing: '1px', padding: '0 16px 12px', textTransform: 'uppercase' }}>Pay Mode</div>
            {[{ value: 'cash', label: 'Cash', icon: '💵' }, { value: 'upi', label: 'UPI', icon: '📱' }, { value: 'card', label: 'Card', icon: '💳' }].map(method => (
              <button key={method.value} className={`pay-tab-btn ${paymentMethod === method.value ? 'active' : ''}`} onClick={() => setPaymentMethod(method.value)}>
                <span style={{ fontSize: '20px' }}>{method.icon}</span>{method.label}
              </button>
            ))}
          </div>

          <div className="pay-center">
            {/* Mobile Payment Tabs */}
            <div className="pay-method-mobile">
              {[{ value: 'cash', label: 'Cash', icon: '💵' }, { value: 'upi', label: 'UPI', icon: '📱' }, { value: 'card', label: 'Card', icon: '💳' }].map(method => (
                <button key={method.value} onClick={() => setPaymentMethod(method.value)} style={{ flex: 1, padding: '10px 8px', border: `2px solid ${paymentMethod === method.value ? '#0066FF' : 'rgba(255,255,255,0.1)'}`, borderRadius: '8px', background: paymentMethod === method.value ? 'rgba(0,102,255,0.1)' : 'transparent', color: paymentMethod === method.value ? '#0066FF' : '#475569', fontSize: '13px', fontWeight: 700, cursor: 'pointer', textAlign: 'center' }}>
                  <div style={{ fontSize: '20px' }}>{method.icon}</div>{method.label}
                </button>
              ))}
            </div>

            {/* Mobile Number */}
            <div className="pay-card">
              <div style={{ fontSize: '11px', fontWeight: 700, color: '#475569', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>Enter Phone Number</div>
              <div style={{ display: 'flex', gap: '10px', marginBottom: showKeypad ? '16px' : '0', alignItems: 'center' }}>
                <input ref={mobileInputRef} type="tel" placeholder="Mobile No." value={customerMobile}
                  onChange={e => { const val = e.target.value.replace(/\D/g, ''); if (val.length <= 10) setCustomerMobile(val); }}
                  onFocus={() => setShowKeypad(true)}
                  className="pay-input" />
                {customerMobile && <button onClick={() => setCustomerMobile('')} style={{ padding: '8px 12px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>Clear</button>}
              </div>
              {showKeypad && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                  {['1','2','3','4','5','6','7','8','9','C','0','⌫'].map(key => (
                    <button key={key} className="kpad-btn" onClick={() => handleKeypad(key)}
                      style={{ background: key === '⌫' ? 'rgba(220,38,38,0.2)' : key === 'C' ? 'rgba(245,158,11,0.2)' : 'rgba(0,102,255,0.2)', color: key === '⌫' ? '#DC2626' : key === 'C' ? '#F59E0B' : 'white', border: `1px solid ${key === '⌫' ? 'rgba(220,38,38,0.3)' : key === 'C' ? 'rgba(245,158,11,0.3)' : 'rgba(0,102,255,0.3)'}` }}>
                      {key}
                    </button>
                  ))}
                </div>
              )}
              {customerMobile.length === 10 && <div style={{ marginTop: '12px', padding: '8px 14px', background: 'rgba(22,163,74,0.1)', border: '1px solid rgba(22,163,74,0.3)', borderRadius: '6px', color: '#16A34A', fontSize: '13px', fontWeight: 700 }}>✅ {customerMobile} — Valid number</div>}
            </div>

            {paymentMethod === 'upi' && (
              <div className="pay-card" style={{ textAlign: 'center', padding: '32px' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>📱</div>
                <div style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '18px', color: 'white', marginBottom: '8px' }}>UPI Payment</div>
                <div style={{ color: '#475569', fontSize: '14px', marginBottom: '16px' }}>Ask customer to scan QR or enter UPI ID</div>
                <div style={{ fontSize: '28px', fontWeight: 800, color: '#0066FF' }}>₹{total.toFixed(2)}</div>
              </div>
            )}

            {paymentMethod === 'card' && (
              <div className="pay-card" style={{ textAlign: 'center', padding: '32px' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>💳</div>
                <div style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '18px', color: 'white', marginBottom: '8px' }}>Card Payment</div>
                <div style={{ color: '#475569', fontSize: '14px', marginBottom: '16px' }}>Please swipe / tap / insert card</div>
                <div style={{ fontSize: '28px', fontWeight: 800, color: '#0066FF' }}>₹{total.toFixed(2)}</div>
              </div>
            )}
          </div>

          {/* Right Summary */}
          <div className="pay-right">
            <div style={{ padding: '14px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ fontSize: '11px', color: '#475569', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase' }}>Booking Summary</div>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '8px 12px' }}>
              {cart.map(item => (
                <div key={item.product_id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{item.product_name} (x{item.quantity})</div>
                    <div style={{ fontSize: '11px', color: '#475569' }}>₹{item.price} each</div>
                  </div>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: 'white' }}>₹{item.total.toFixed(2)}</div>
                </div>
              ))}
            </div>
            <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              {customerMobile && (
                <div style={{ marginBottom: '10px', padding: '8px 12px', background: 'rgba(255,255,255,0.04)', borderRadius: '6px', fontSize: '13px', color: '#475569', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>📱 {customerMobile}</span>
                  <button onClick={() => { setShowKeypad(true); mobileInputRef.current?.focus(); }} style={{ background: 'none', border: 'none', color: '#0066FF', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>Edit</button>
                </div>
              )}
              <div style={{ marginBottom: '8px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569', marginBottom: '4px' }}><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#475569' }}><span>GST ({gstPercent}%)</span><span>₹{gstAmount.toFixed(2)}</span></div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.2)', borderRadius: '8px', marginBottom: '12px' }}>
                <span style={{ color: 'white', fontWeight: 600, fontSize: '13px' }}>Balance Due</span>
                <span style={{ color: '#0066FF', fontWeight: 800, fontSize: '18px' }}>₹{total.toFixed(2)}</span>
              </div>
              <button onClick={handleCreateBill} disabled={loading} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', border: 'none', borderRadius: '6px', fontSize: '14px', fontWeight: 800, cursor: 'pointer', letterSpacing: '1px' }}>
                {loading ? 'Processing...' : 'Confirm Payment'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // STEP 3
  if (step === 3) return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{styles}</style>

      <div className="pos-mobile-hdr">
        <button onClick={() => setStep(2)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white' }}>RECEIPT</span>
        <span />
      </div>

      <div className={`pos-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />
      <Sidebar />

      <div className="rec-center">
        <div className="rec-box">
          <div style={{ padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '16px', color: 'white', letterSpacing: '1px' }}>PLEASE PROCEED</div>
              <div style={{ fontSize: '12px', color: '#475569', marginTop: '2px' }}>{bill?.bill_number} • ₹{bill?.total?.toFixed(2)} • {bill?.payment_method?.toUpperCase()}</div>
            </div>
            <button onClick={handleNewBill} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#475569' }}>✕</button>
          </div>

          <div style={{ padding: '20px' }}>
            {/* Mobile Number */}
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, color: '#475569', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>Customer Mobile Number</div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: showReceiptKeypad ? '12px' : '0' }}>
                <input type="tel" placeholder="Enter mobile number" value={receiptMobile}
                  onChange={e => { const val = e.target.value.replace(/\D/g, ''); if (val.length <= 10) setReceiptMobile(val); }}
                  onFocus={() => setShowReceiptKeypad(true)}
                  style={{ flex: 1, padding: '10px 16px', border: '2px solid ' + (showReceiptKeypad ? '#0066FF' : 'rgba(255,255,255,0.1)'), borderRadius: '8px', fontSize: '20px', fontWeight: 800, color: 'white', letterSpacing: '3px', outline: 'none', background: 'rgba(255,255,255,0.05)' }} />
                {receiptMobile && <button onClick={() => { setReceiptMobile(''); setShowReceiptKeypad(true); }} style={{ padding: '6px 12px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>Edit</button>}
              </div>
              {showReceiptKeypad && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                  {['1','2','3','4','5','6','7','8','9','C','0','⌫'].map(key => (
                    <button key={key} className="kpad-btn" onClick={() => handleReceiptKeypad(key)}
                      style={{ background: key === '⌫' ? 'rgba(220,38,38,0.2)' : key === 'C' ? 'rgba(245,158,11,0.2)' : 'rgba(0,102,255,0.2)', color: key === '⌫' ? '#DC2626' : key === 'C' ? '#F59E0B' : 'white', border: `1px solid ${key === '⌫' ? 'rgba(220,38,38,0.3)' : key === 'C' ? 'rgba(245,158,11,0.3)' : 'rgba(0,102,255,0.3)'}` }}>
                      {key}
                    </button>
                  ))}
                </div>
              )}
              {receiptMobile.length === 10 && <div style={{ marginTop: '8px', padding: '6px 12px', background: 'rgba(22,163,74,0.1)', border: '1px solid rgba(22,163,74,0.3)', borderRadius: '6px', color: '#16A34A', fontSize: '12px', fontWeight: 700 }}>✅ {receiptMobile} — We will send booking details via SMS</div>}
            </div>

            {/* Receipt Options */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '14px', marginBottom: '20px' }}>
              {/*<button className={`rec-opt-btn ${receiptType === 'sms' ? 'selected' : ''}`} onClick={() => setReceiptType('sms')}>
                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '48px', height: '48px', background: 'rgba(0,102,255,0.2)', border: '1px solid rgba(0,102,255,0.3)', borderRadius: '8px', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '3px', padding: '6px' }}>
                    {[1,1,0,1,0,1,0,1,1].map((v,i) => <div key={i} style={{ background: v ? '#0066FF' : 'transparent', borderRadius: '2px' }} />)}
                  </div>
                </div>
                <div style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '12px', color: 'white', marginBottom: '4px' }}>M-RECEIPT</div>
                <div style={{ fontSize: '10px', color: '#475569', lineHeight: 1.4 }}>QR code via SMS</div>
                {receiptType === 'sms' && <div style={{ marginTop: '6px', background: '#0066FF', borderRadius: '4px', padding: '3px', fontSize: '10px', fontWeight: 700, color: 'white' }}>SELECTED ✓</div>}
              </button>*/}

              <button className={`rec-opt-btn ${receiptType === 'print' ? 'selected' : ''}`} onClick={() => setReceiptType('print')}>
                <div style={{ marginBottom: '10px', fontSize: '44px' }}>🖨️</div>
                <div style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '12px', color: 'white', marginBottom: '4px' }}>PHYSICAL RECEIPT</div>
                <div style={{ fontSize: '10px', color: '#475569', lineHeight: 1.4 }}>Print & hand over</div>
                {receiptType === 'print' && <div style={{ marginTop: '6px', background: '#0066FF', borderRadius: '4px', padding: '3px', fontSize: '10px', fontWeight: 700, color: 'white' }}>SELECTED ✓</div>}
              </button>
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setStep(2)} style={{ flex: 1, padding: '12px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', color: '#475569' }}>← BACK</button>
              <button onClick={handleProceed} style={{ flex: 2, padding: '12px', background: receiptType ? 'linear-gradient(135deg, #0066FF, #0052CC)' : 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 800, cursor: receiptType ? 'pointer' : 'not-allowed', color: receiptType ? 'white' : '#475569' }}>PROCEED →</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default POSBilling;
